module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-switch', {
    attrs: {
      "off-text": _vm.options[0].label,
      "on-text": _vm.options[1].label,
      "off-color": _vm._f("color")(_vm.options[0].style),
      "on-color": _vm._f("color")(_vm.options[1].style),
      "width": _vm.width
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0695941a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmartForm/SmartFormItem/SmartSwitch.vue
// module id = 1684
// module chunks = 1